// extracted by mini-css-extract-plugin
export default {"pageWrap":"UserSearchPage_pageWrap__MDVFj","userTableWrap":"UserSearchPage_userTableWrap__8yyE3","top":"UserSearchPage_top__XDPzo"};